export enum NetworkState {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  UNKNOWN = 'UNKNOWN',
}

export enum NetworkConnectionType {
  DISCONNECTED = 'DISCONNECTED',
  CELLULAR = 'CELLULAR',
  ETHERNET = 'ETHERNET',
  WIFI = 'WIFI',
  UNKNOWN = 'UNKNOWN',
}

export enum NetworkIpMode {
  NONE = 'NONE',
  STATIC = 'STATIC',
  DYNAMIC = 'DYNAMIC',
  AUTO = 'AUTO',
  FIXED = 'FIXED',
  UNKNOWN = 'UNKNOWN',
}

export interface NetworkData {
  type: NetworkConnectionType
  macAddress: string
  ipAddress: string
  ipMode: NetworkIpMode
  subnetMask: string
  gateway: string
  primaryDns: string
  secondaryDns: string
  proxy: string
  wifi?: NetworkWifiData
  softAP?: NetworkSoftAP
}

export interface NetworkWifiData {
  ssid: string
  signalStrengthLevel: number
  securityMode: string
  encryptionType: string
  frequency?: number
}

export interface NetworkSoftAP {
  enabled: boolean
  ssid: string
  securityKey: string
}
